<template>
  <v-card class="component-setup-card" style="height: 90vh">
    <v-card-title>
      <span class="toolbar_title">{{ dialogTitle }}</span>
      <v-spacer></v-spacer>
      <v-btn icon :disabled="audience_saving" @click="closeSetup">
        <v-icon color="black">mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <div v-if="is_loading_components" class="component-loading-state" role="status">
      <v-progress-circular
        indeterminate
        color="primary"
        :size="150"
        width="5"
        :aria-label="audience_only ? 'Loading available audiences' : 'Loading available components'"
      ></v-progress-circular>
    </div>
    <div class="component-info-tab" style="height: 73vh">
        <v-row class="ma-0 px-3 pb-3 component-info-layout" :class="{ 'component-info-layout--audience': audience_only }">
          <v-col v-if="!audience_only" cols="12" class="ma-0 px-3 pt-6 pb-0">
              <v-text-field
                v-model="component_data['plan']['name']"
                label="Component Name"
                outlined
                hide-details="auto"
                required
                :disabled="is_loading_components"
              ></v-text-field>
              <div v-if="audience_managed" class="caption mt-2 grey--text text--darken-1">
                Uses the shared plan audience. Update it from Plan Audience in the plan toolbar.
              </div>
            </v-col>
          <v-col v-if="!audience_only" cols="12" md="5" class="component-section-column">
            <v-card outlined class="component-definition-card">
              <v-card-title>Component Definition</v-card-title>
              <v-card-text class="pa-0 component-definition-content">
            <v-col cols="12">
              <v-select
                v-model="component_data['CPF']['partner']"
                label="Operator"
                hide-details
                outlined
                :disabled="is_loading_components"
                :items="partner_options"
                @change="
                  component_data['CPF']['market'] = null;
                  component_data['CPF']['channel'] = null;
                  component_data['CPF']['product'] = null;
                  component_data['CPF']['format'] = null;
                "
              ></v-select>
            </v-col>
            <v-col cols="12">
              <v-select
                v-model="component_data['CPF']['market']"
                label="Market"
                hide-details
                outlined
                :items="grouped_market_options"
                :menu-props="{ contentClass: 'sweetspot-market-menu' }"
                @change="
                  component_data['CPF']['channel'] = null;
                  component_data['CPF']['product'] = null;
                  component_data['CPF']['format'] = null;
                "
                :disabled="is_loading_components || component_data['CPF']['partner'] == null"
              >
                <template v-slot:item="{ item, attrs, on }">
                  <v-list-item
                    v-if="item.groupHeader"
                    :ripple="false"
                    class="market-group-heading"
                    @mousedown.prevent
                  >
                    <button
                    type="button"
                    class="market-group-toggle"
                    :aria-expanded="String(!collapsed_market_groups[item.group])"
                    @click.stop="collapsed_market_groups[item.group] = !collapsed_market_groups[item.group]"
                  >
                    <span>{{ item.text }}</span>
                    <v-icon small>{{ collapsed_market_groups[item.group] ? 'mdi-chevron-right' : 'mdi-chevron-down' }}</v-icon>
                    </button>
                  </v-list-item>
                  <v-list-item
                    v-else
                    v-show="!collapsed_market_groups[item.group]"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-list-item-title>{{ item.text }}</v-list-item-title>
                  </v-list-item>
                </template>
              </v-select>
            </v-col>
            <v-col cols="12">
              <v-select
                v-model="component_data['CPF']['channel']"
                label="Channel"
                hide-details
                outlined
                :disabled="is_loading_components || component_data['CPF']['market'] == null"
                :items="channel_options"
                @change="
                  component_data['CPF']['product'] = null;
                  component_data['CPF']['format'] = null;
                "
              ></v-select>
            </v-col>
            <v-col cols="12">
              <v-select
                v-model="component_data['CPF']['product']"
                label="Product"
                hide-details
                outlined
                :disabled="is_loading_components || component_data['CPF']['channel'] == null"
                :items="product_options"
                @change="component_data['CPF']['format'] = null"
              ></v-select>
            </v-col>
            <v-col cols="12">
              <v-select
                v-model="component_data['CPF']['format']"
                label="Format"
                hide-details
                outlined
                :disabled="is_loading_components || component_data['CPF']['product'] == null"
                :items="format_options"
              ></v-select>
            </v-col>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" :md="audience_only ? 12 : 7" class="component-section-column">
            <v-card outlined class="other-variables-card">
              <v-tabs
                v-if="!audience_only"
                v-model="variables_tab"
                class="variables-tabs"
                background-color="transparent"
                color="primary"
                height="38"
                hide-slider
                grow
                show-arrows
              >
                <v-tab :disabled="is_loading_components">
                  <v-icon size="17" class="mr-2">mdi-tune-variant</v-icon>
                  General
                </v-tab>
                <v-tab :disabled="is_loading_components || cpm_options == null || !is_pattison_product || !digital_options" aria-label="Day Parting Schedule">
                  <v-icon size="17" class="mr-2">mdi-clock-outline</v-icon>
                  Day Parting
                </v-tab>
                <v-tab v-if="!audience_managed" :disabled="is_loading_components">
                  <v-icon size="17" class="mr-2">mdi-account-group-outline</v-icon>
                  Audience
                </v-tab>
              </v-tabs>
              <v-tabs-items v-model="setup_tab" class="other-variables-content">
                <v-tab-item :value="0" v-if="!audience_only">
                  <div class="pa-4">
                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          v-model="component_data['plan']['weeks']"
                          label="Weeks in Market"
                          type="number"
                          min="1"
                          max="52"
                          @blur="normalizeWeeks"
                          @change="normalizeWeeks"
                          outlined
                          hide-details="auto"
                          :disabled="is_loading_components || cpm_options == null"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" class="pb-0">
                        <div class="scheduler_title">CPM</div>
                        <div class="scheduler_subtitle">Set Custom Pricing &amp; Discounts</div>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          v-model="component_data['CPF']['cpm']"
                          label="CPM"
                          outlined
                          hide-details="auto"
                          required
                          type="number"
                          :disabled="is_loading_components || cpm_options == null"
                          prefix="$"
                          step="0.01"
                          @blur="normalizeCpm"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          v-model="component_data['CPF']['discount']"
                          label="Discount"
                          outlined
                          hide-details="auto"
                          required
                          type="number"
                          :disabled="is_loading_components || cpm_options == null"
                          suffix="%"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" class="pb-0">
                        <div
                          class="scheduler_title"
                          :class="{ 'scheduler_title_disabled': is_pattison_product }"
                        >Frequency Cap</div>
                        <div class="scheduler_subtitle">Limit how often an ad is shown. Use 0 for no cap.</div>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          v-model.number="component_data['plan']['freq_cap']"
                          label="Frequency cap"
                          type="number"
                          min="0"
                          step="1"
                          outlined
                          hide-details="auto"
                          :rules="[value => isValidFrequencyCap(value) || 'Enter a whole number of 0 or more.']"
                          :disabled="is_loading_components || cpm_options == null || is_pattison_product"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-select
                          v-model="component_data['plan']['freq_cap_period']"
                          label="Time period"
                          :items="frequency_cap_period_options"
                          outlined
                          hide-details="auto"
                          :disabled="is_loading_components || cpm_options == null || is_pattison_product"
                        ></v-select>
                      </v-col>
                    </v-row>
                  </div>
                </v-tab-item>
                <v-tab-item :value="1" v-if="!audience_only">
                <v-card outlined class="event-scheduler-card">
                  <v-card-title class="pb-2 event-scheduler-header">
                    <div class="scheduler-header-content">
                      <div>
                        <div class="scheduler_title">Day Parting Schedule</div>
                        <div class="scheduler_subtitle">
                          Choose one shared schedule for the week or fine-tune each
                          weekday.
                        </div>
                      </div>
                      <div class="scheduler-summary-row">
                        <v-alert
                          v-if="
                            schedule_validation_attempted && schedule_validation_message
                          "
                          dense
                          outlined
                          type="warning"
                          class="mb-0 scheduler-summary-alert"
                        >
                          {{ schedule_validation_message }}
                        </v-alert>
                        <v-alert
                          v-else
                          dense
                          text
                          color="blue-grey"
                          class="mb-0 scheduler-summary-alert"
                        >
                          {{ schedule_summary }}
                        </v-alert>
                      </div>
                    </div>
                  </v-card-title>

                  <v-card-text class="pt-0">
                    <v-radio-group
                      v-model="component_data['plan']['schedule_mode']"
                      row
                      class="pt-2 pb-4"
                      hide-details
                      @change="handleScheduleModeChange"
                      :disabled="is_loading_components"
                    >
                      <v-radio label="Default" value="default" :disabled="is_loading_components || !digital_options"></v-radio>
                      <v-radio label="Same every day" value="same_every_day" :disabled="is_loading_components || !digital_options"></v-radio>
                      <v-radio label="By weekday" value="by_weekday" :disabled="is_loading_components || !digital_options"></v-radio>
                    </v-radio-group>

                    <template
                      v-if="
                        component_data['plan']['schedule_mode'] === 'default' ||
                        component_data['plan']['schedule_mode'] === 'same_every_day'
                      "
                    >
                      <v-row dense class="shared-schedule-layout">
                        <v-col cols="12">
                          <div class="scheduler_label">Days</div>
                          <div class="day-chip-list">
                            <v-chip
                              v-for="day in days_of_week"
                              :key="day.value"
                              small
                              :color="
                                shared_schedule_active_days.includes(day.value)
                                  ? 'primary'
                                  : ''
                              "
                              :input-value="
                                shared_schedule_active_days.includes(day.value)
                              "
                              :outlined="!shared_schedule_active_days.includes(day.value)"
                              :disabled="is_loading_components || isDefaultScheduleMode"
                              @click="handleSharedDayToggle(day.value)"
                            >
                              {{ day.label }}
                            </v-chip>
                          </div>
                        </v-col>
                        <v-col cols="12">
                          <div class="scheduler_label">Time Slots</div>
                          <div
                            v-for="(slot, slotIndex) in shared_schedule_time_slots"
                            :key="`shared-slot-${slotIndex}`"
                            class="time-slot-row pa-3"
                          >
                            <v-row dense align="center">
                              <v-col cols="12" sm="2">
                                <div class="slot-name">Slot {{ slotIndex + 1 }}</div>
                              </v-col>
                              <v-col cols="5" sm="4">
                                <v-select
                                  :value="slot.start"
                                  label="Start time"
                                  :items="time_options"
                                  :disabled="is_loading_components || isDefaultScheduleMode"
                                  dense
                                  outlined
                                  hide-details
                                  @change="
                                    handleSharedTimeChange(slotIndex, 'start', $event)
                                  "
                                ></v-select>
                              </v-col>
                              <v-col cols="5" sm="4">
                                <v-select
                                  :value="slot.end"
                                  label="End time"
                                  :items="time_options"
                                  :disabled="is_loading_components || isDefaultScheduleMode"
                                  dense
                                  outlined
                                  hide-details
                                  @change="
                                    handleSharedTimeChange(slotIndex, 'end', $event)
                                  "
                                ></v-select>
                              </v-col>
                              <v-col cols="2" sm="2" class="text-right">
                                <v-btn
                                  icon
                                  small
                                  :disabled="is_loading_components ||
                                    isDefaultScheduleMode ||
                                    shared_schedule_time_slots.length === 1
                                  "
                                  @click="removeSharedTimeSlot(slotIndex)"
                                >
                                  <v-icon small>mdi-close</v-icon>
                                </v-btn>
                              </v-col>
                            </v-row>
                          </div>
                          <v-btn
                            small
                            text
                            color="primary"
                            class="mt-2"
                            :disabled="is_loading_components || isDefaultScheduleMode"
                            @click="addSharedTimeSlot"
                          >
                            <v-icon left small>mdi-plus</v-icon>
                            Add time slot
                          </v-btn>
                        </v-col>
                      </v-row>
                    </template>

                    <template v-else>
                      <div>
                        <div
                          v-for="day in days_of_week"
                          :key="day.value"
                          class="weekday-schedule-row pa-3"
                        >
                          <v-row dense align="center">
                            <v-col cols="12" sm="6">
                              <div class="weekday-name">{{ day.fullLabel }}</div>
                            </v-col>
                            <v-col cols="12" sm="4" class="weekday-switch-col">
                              <v-switch
                                :input-value="
                                  component_data['plan']['weekday_schedules'][day.value]
                                    .enabled
                                "
                                inset
                                dense
                                hide-details
                                @change="handleWeekdayEnabledChange(day.value, $event)"
                                :disabled="is_loading_components"
                              ></v-switch>
                            </v-col>
                            <v-col cols="12" sm="2" class="text-sm-right">
                              <v-btn
                                small
                                text
                                color="primary"
                                :disabled="is_loading_components ||
                                  !component_data['plan']['weekday_schedules'][day.value]
                                    .enabled
                                "
                                @click="addWeekdayTimeSlot(day.value)"
                              >
                                <v-icon left small>mdi-plus</v-icon>
                                Add time slot
                              </v-btn>
                            </v-col>
                          </v-row>
                          <div
                            v-if="
                              component_data['plan']['weekday_schedules'][day.value]
                                .enabled
                            "
                            class="mt-2"
                          >
                            <div
                              v-for="(slot, slotIndex) in component_data['plan'][
                                'weekday_schedules'
                              ][day.value].time_slots"
                              :key="`${day.value}-slot-${slotIndex}`"
                              class="time-slot-row pa-3"
                            >
                              <v-row dense align="center">
                                <v-col cols="12" sm="2">
                                  <div class="slot-name">Slot {{ slotIndex + 1 }}</div>
                                </v-col>
                                <v-col cols="5" sm="4">
                                  <v-select
                                    :value="slot.start"
                                    label="Start"
                                    :items="time_options"
                                    dense
                                    outlined
                                    hide-details
                                    @change="
                                      handleWeekdayTimeChange(
                                        day.value,
                                        slotIndex,
                                        'start',
                                        $event
                                      )
                                    "
                                    :disabled="is_loading_components"
                                  ></v-select>
                                </v-col>
                                <v-col cols="5" sm="4">
                                  <v-select
                                    :value="slot.end"
                                    label="End"
                                    :items="time_options"
                                    dense
                                    outlined
                                    hide-details
                                    @change="
                                      handleWeekdayTimeChange(
                                        day.value,
                                        slotIndex,
                                        'end',
                                        $event
                                      )
                                    "
                                    :disabled="is_loading_components"
                                  ></v-select>
                                </v-col>
                                <v-col cols="2" sm="2" class="text-right">
                                  <v-btn
                                    icon
                                    small
                                    :disabled="is_loading_components ||
                                      component_data['plan']['weekday_schedules'][
                                        day.value
                                      ].time_slots.length === 1
                                    "
                                    @click="removeWeekdayTimeSlot(day.value, slotIndex)"
                                  >
                                    <v-icon small>mdi-close</v-icon>
                                  </v-btn>
                                </v-col>
                              </v-row>
                            </div>
                          </div>
                          <div v-else class="weekday-off-text mt-2">No time slots</div>
                        </div>
                      </div>
                    </template>
                  </v-card-text>
                </v-card>
                </v-tab-item>
                <v-tab-item :value="2">
                  <div class="pa-4 pb-0">
                    <div class="audience-source-switch" role="group" aria-label="Audience source">
                      <button
                        v-for="option in audience_mode_options"
                        :key="option.value"
                        type="button"
                        class="audience-source-option"
                        :class="{ 'audience-source-option--active': audience_mode === option.value }"
                        :aria-pressed="audience_mode === option.value"
                        :disabled="is_loading_components"
                        @click="audience_mode = option.value"
                      >
                        <span class="audience-source-icon">
                          <v-icon size="16" :color="audience_mode === option.value ? 'primary' : undefined">{{ option.icon }}</v-icon>
                        </span>
                        <span class="audience-source-copy">
                          <span class="audience-source-title">{{ option.text }}</span>
                          <span class="audience-source-description">{{ option.description }}</span>
                        </span>
                        <v-icon v-if="audience_mode === option.value" size="15" color="primary">mdi-check-circle</v-icon>
                      </button>
                    </div>
                  </div>
                  <div v-if="audience_mode === 'existing_audience'" class="pa-4">
                    <v-autocomplete
                      v-model="selected_audience_key"
                      :items="saved_audience_options"
                      label="Saved Audience"
                      outlined
                      hide-details="auto"
                      :rules="[() => audience_validation_message || true]"
                      :disabled="is_loading_components"
                      no-data-text="No saved audiences available"
                    ></v-autocomplete>
                    <div v-if="selected_saved_audience && selected_saved_audience.audience_size != null" class="mt-3">
                      Audience Size: {{ Number(selected_saved_audience.audience_size).toLocaleString('en-US') }}
                    </div>
                  </div>
                  <div v-if="audience_only && audience_mode === 'custom'" class="px-4 pt-4">
                    <v-select v-model="custom_audience_type" :items="[{ text: 'Enter name and size', value: 'inputted_value' }, { text: 'Build with variables', value: 'relational_algebra', disabled: true }]" label="Audience Method" :disabled="is_loading_components" outlined dense hide-details></v-select>
                  </div>
                  <div v-if="audience_mode === 'custom' && uses_inputted_audience" class="pa-4">
                    <v-text-field
                      v-model="component_data.plan.audience_name"
                      label="Audience Name"
                      outlined
                      hide-details="auto"
                      class="mb-4"
                      :disabled="is_loading_components"
                    ></v-text-field>
                    <v-text-field
                      ref="audienceSizeInput"
                      :value="formatted_audience_size"
                      @input="updateAudienceSize"
                      label="Audience Size"
                      type="text"
                      inputmode="numeric"
                      :hint="market_max_audience_size ? `Market maximum: ${market_max_audience_size.toLocaleString()}` : 'Market maximum unavailable for this selection.'"
                      persistent-hint
                      outlined
                      hide-details="auto"
                      :rules="[() => audience_validation_message || true]"
                      :disabled="is_loading_components"
                    ></v-text-field>
                  </div>
                  <v-row v-if="audience_mode === 'custom' && !uses_inputted_audience" class="ma-0 pa-0 audience-builder" style="height: 73vh">
                    <v-col cols="12" md="5" class="pa-6 audience-builder__sidebar">
                      <v-card outlined class="audience-builder-card">
                        <v-card-title class="pb-2">
                          <div>
                            <div class="scheduler_title">Audience Variables</div>
                            <div class="scheduler_subtitle">
                              Browse the available demographic and behavioral codes.
                            </div>
                          </div>
                        </v-card-title>
                        <v-card-text>
                          <v-text-field
                            v-model="audience_variable_search"
                            label="Search variables"
                            outlined
                            dense
                            hide-details
                            prepend-inner-icon="mdi-magnify"
                            class="mb-4"
                            :disabled="is_loading_components"
                          ></v-text-field>
                          <v-expansion-panels accordion flat>
                            <v-expansion-panel
                              v-for="variable in filtered_audience_variables"
                              :key="variable.var_id"
                            >
                              <v-expansion-panel-header>
                                <div>
                                  <div class="audience-variable-name">
                                    {{ variable.var_id_name || variable.var_id }}
                                  </div>
                                  <div class="audience-variable-code-count">
                                    {{ variable.codes.length }} codes
                                  </div>
                                </div>
                              </v-expansion-panel-header>
                              <v-expansion-panel-content>
                                <v-chip
                                  v-for="code in variable.codes"
                                  :key="`${variable.var_id}-${code.var_code}`"
                                  small
                                  outlined
                                  class="mr-2 mb-2"
                                  :disabled="is_loading_components"
                                >
                                  {{ code.var_code_name || code.var_code }}
                                </v-chip>
                              </v-expansion-panel-content>
                            </v-expansion-panel>
                          </v-expansion-panels>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" md="7" class="pa-6 audience-builder__workspace">
                      <v-card outlined class="audience-builder-card">
                        <v-card-title class="pb-2 audience-builder-header">
                          <div>
                            <div class="scheduler_title">Audience Algebra</div>
                            <div class="scheduler_subtitle">
                              Combine variable code sets into a targetable audience.
                            </div>
                          </div>
                          <v-spacer></v-spacer>
                          <v-btn small text color="primary" @click="addAudienceClause" :disabled="is_loading_components">
                            <v-icon left small>mdi-plus</v-icon>
                            Add clause
                          </v-btn>
                        </v-card-title>
                        <v-card-text>
                          <v-alert
                            v-if="audience_validation_attempted && audience_validation_message"
                            dense
                            outlined
                            type="warning"
                            class="mb-4"
                          >
                            {{ audience_validation_message }}
                          </v-alert>
                          <div
                            v-for="(clause, clauseIndex) in component_data['audience']['clauses']"
                            :key="clause.id"
                            class="audience-clause-row pa-3"
                          >
                            <v-row dense align="center">
                              <v-col cols="12" sm="2" v-if="clauseIndex > 0">
                                <v-select
                                  v-model="clause.join"
                                  :items="audience_join_options"
                                  label="Join"
                                  dense
                                  outlined
                                  hide-details
                                  :disabled="is_loading_components"
                                ></v-select>
                              </v-col>
                              <v-col cols="12" sm="2" v-else>
                                <div class="audience-clause-label">Clause {{ clauseIndex + 1 }}</div>
                              </v-col>
                              <v-col cols="12" sm="2">
                                <v-switch
                                  v-model="clause.negated"
                                  label="NOT"
                                  inset
                                  dense
                                  hide-details
                                  :disabled="is_loading_components"
                                ></v-switch>
                              </v-col>
                              <v-col cols="12" sm="4">
                                <v-select
                                  v-model="clause.var_id"
                                  :items="audience_variable_options"
                                  label="Variable"
                                  dense
                                  outlined
                                  hide-details
                                  @change="handleAudienceVariableChange(clause)"
                                  :disabled="is_loading_components"
                                ></v-select>
                              </v-col>
                              <v-col cols="12" sm="3">
                                <v-select
                                  v-model="clause.var_codes"
                                  :items="getAudienceCodeOptions(clause.var_id)"
                                  label="Codes"
                                  multiple
                                  chips
                                  small-chips
                                  dense
                                  outlined
                                  hide-details
                                  :disabled="is_loading_components || !clause.var_id"
                                ></v-select>
                              </v-col>
                              <v-col cols="12" sm="1" class="text-right">
                                <v-btn
                                  icon
                                  small
                                  :disabled="is_loading_components || component_data['audience']['clauses'].length === 1"
                                  @click="removeAudienceClause(clauseIndex)"
                                >
                                  <v-icon small>mdi-close</v-icon>
                                </v-btn>
                              </v-col>
                            </v-row>
                          </div>
                          <v-divider class="my-4"></v-divider>
                          <div class="scheduler_label">Expression</div>
                          <div class="audience-expression pa-3">{{ audience_expression_summary }}</div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-tab-item>
              </v-tabs-items>
            </v-card>
          </v-col>
        </v-row>
    </div>
    <v-row class="ma-0 pa-0" cols="12" justify="space-around">
      <v-col cols="3">
        <v-btn
          style="width: 100%"
          outlined
          color="black"
          @click="save_component"
          :loading="audience_saving"
          :disabled="is_loading_components || create_disabled || is_submitting || audience_saving"
        >
          <span class="actionBtn">{{ actionButtonText }}</span>
        </v-btn>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import sweetspot_reporting_api_caller from "@/javascript/sweetspot_reporting.js";
import { audienceForPayload } from "@/javascript/sweetspot_audience.js";

const DAYS_OF_WEEK = [
  { label: "Mon", value: "monday", fullLabel: "Monday" },
  { label: "Tue", value: "tuesday", fullLabel: "Tuesday" },
  { label: "Wed", value: "wednesday", fullLabel: "Wednesday" },
  { label: "Thu", value: "thursday", fullLabel: "Thursday" },
  { label: "Fri", value: "friday", fullLabel: "Friday" },
  { label: "Sat", value: "saturday", fullLabel: "Saturday" },
  { label: "Sun", value: "sunday", fullLabel: "Sunday" },
];

const TIME_OPTIONS = Array.from({ length: 24 }, (_, hour) => {
  const paddedHour = `${hour}`.padStart(2, "0");
  return `${paddedHour}:00`;
}).concat("23:59");

function createScheduleWindow(enabled = true) {
  return {
    enabled,
    time_slots: [createTimeSlot()],
  };
}

function createTimeSlot(start = "09:00", end = "17:00") {
  return {
    start,
    end,
  };
}

function createDefaultTimeSlot() {
  return createTimeSlot("00:00", "23:59");
}

function createWeekdayScheduleMap() {
  return DAYS_OF_WEEK.reduce((scheduleMap, day) => {
    scheduleMap[day.value] = createScheduleWindow(true);
    return scheduleMap;
  }, {});
}

function createDefaultWeekdayScheduleMap() {
  return DAYS_OF_WEEK.reduce((scheduleMap, day) => {
    scheduleMap[day.value] = {
      enabled: true,
      time_slots: [createDefaultTimeSlot()],
    };
    return scheduleMap;
  }, {});
}

let audienceClauseId = 0;

function createAudienceClause(join = "AND") {
  audienceClauseId += 1;
  return {
    id: audienceClauseId,
    join,
    negated: false,
    var_id: null,
    var_codes: [],
  };
}

function cloneWeekdayScheduleMap(weekdaySchedules = {}) {
  return DAYS_OF_WEEK.reduce((scheduleMap, day) => {
    const sourceSchedule = weekdaySchedules[day.value];

    scheduleMap[day.value] = {
      enabled: sourceSchedule ? sourceSchedule.enabled : true,
      time_slots: sourceSchedule
        ? sourceSchedule.time_slots.map((slot) => ({
            start: slot.start,
            end: slot.end,
          }))
        : [createTimeSlot()],
    };

    return scheduleMap;
  }, {});
}

export default {
  name: "SweetSpotSetup",
  props: ["report_id", "mode", "edit_component_data", "audience_only", "shared_audience", "audience_managed", "audience_saving", "audience_components"],
  data: () => ({
    variables_tab: 0,
    is_initializing_component_data: false,
    component_data: {
      CPF: {
        market: null,
        partner: null,
        channel: null,
        product: null,
        format: null,
        cpm: null,
        discount: null,
        digital: null
      },
      plan: {
        name: "",
        weeks: 4,
        audience_name: "",
        audience_size: null,
        cpm: 5,
        freq_cap: 3,
        freq_cap_period: 1,
        schedule_mode: "default",
        weekday_schedules: createDefaultWeekdayScheduleMap(),
      },
      audience: {
        clauses: [createAudienceClause()],
      },
    },
    inventory_options: {},
    custom_audience_type: "inputted_value",
    audience_options: [],
    audience_mode: "custom",
    selected_audience_key: null,
    audience_variables: [],
    audience_variable_search: "",
    available_markets: [],
    collapsed_market_groups: { Provincial: false, CMA: false },
    frequency_cap_period_options: [
      { text: "Daily", value: 1 },
      { text: "Weekly", value: 7 },
      { text: "Monthly", value: 30 },
    ],
    last_non_default_weekday_schedules: createWeekdayScheduleMap(),
    previous_schedule_mode: "default",
    schedule_validation_attempted: false,
    audience_validation_attempted: false,
    audience_join_options: ["AND", "OR"],
    is_submitting: false,
    is_loading_components: true,
  }),
  created() {
    if (this.audience_only) this.restoreSharedAudience(this.shared_audience);
  },
  async mounted() {
    await this.fetch_component_options();
    this.applyInitialComponentData();
    if (this.audience_only) {
      this.restoreSharedAudience(this.shared_audience);
    }
  },
  computed: {
    setup_tab: {
      get() {
        return this.audience_only ? 2 : this.variables_tab;
      },
      set(value) {
        if (!this.audience_only) this.variables_tab = value;
      },
    },
    is_google_product() {
      const { partner, product } = this.component_data.CPF;
      return product != null && /google/i.test(partner || "");
    },
    is_pattison_product() {
      const { partner, product } = this.component_data.CPF;
      return product != null && /pattison/i.test(partner || "");
    },
    is_edit_mode() {
      return this.mode === "edit";
    },
    is_create_mode() {
      return !this.is_edit_mode;
    },
    dialogTitle() {
      if (this.audience_only) return "Plan Audience";
      return this.is_edit_mode ? "Edit Component" : "Create New Component";
    },
    actionButtonText() {
      if (this.audience_only) return "Apply to All Line Items";
      return this.is_edit_mode ? "Save Changes" : "Create";
    },
    partner_options() {
      return [...new Set(
        this.available_markets.flatMap((market) =>
          Object.keys(this.inventory_options[market] || {}).filter((key) => key !== "mkt_id")
        )
      )];
    },
    market_options() {
      const operator = this.component_data["CPF"]["partner"];
      if (operator == null) {
        return [];
      }

      return this.available_markets.filter((market) =>
        Object.prototype.hasOwnProperty.call(this.inventory_options[market] || {}, operator)
      );
    },
    grouped_market_options() {
      const provincial = [];
      const cma = [];
      this.market_options.forEach((market) => {
        const marketId = String(this.inventory_options[market]?.mkt_id ?? "").trim();
        // Market IDs encode geography: two digits for provinces, five for CMAs.
        const group = /^\d{2}$/.test(marketId) ? provincial
          : /^\d{5}$/.test(marketId) ? cma : null;
        if (!group) return;
        const level = group === provincial ? "Provincial" : "CMA";
        group.push({ text: market, value: market, group: level, disabled: this.collapsed_market_groups[level] });
      });
      return [
        ...(provincial.length ? [{ text: "Provincial", value: "__provincial_header", groupHeader: true, group: "Provincial", disabled: true }, ...provincial] : []),
        ...(provincial.length && cma.length ? [{ divider: true }] : []),
        ...(cma.length ? [{ text: "CMA", value: "__cma_header", groupHeader: true, group: "CMA", disabled: true }, ...cma] : []),
      ];
    },
    channel_options() {
      if (
        this.component_data["CPF"]["market"] == null ||
        this.component_data["CPF"]["partner"] == null
      ) {
        return [];
      }

      return Object.keys(
        this.inventory_options[this.component_data["CPF"]["market"]]?.[
          this.component_data["CPF"]["partner"]
        ] || {}
      );
    },
    product_options() {
      if (
        this.component_data["CPF"]["market"] == null ||
        this.component_data["CPF"]["partner"] == null ||
        this.component_data["CPF"]["channel"] == null
      ) {
        return [];
      }

      return Object.keys(
        this.inventory_options[this.component_data["CPF"]["market"]]?.[this.component_data["CPF"]["partner"]]?.[this.component_data["CPF"]["channel"]] || {}
      );
    },
    format_options() {
      if (
        this.component_data["CPF"]["market"] == null ||
        this.component_data["CPF"]["partner"] == null ||
        this.component_data["CPF"]["channel"] == null ||
        this.component_data["CPF"]["product"] == null
      ) {
        return [];
      }

      return Object.keys(
        this.inventory_options[this.component_data["CPF"]["market"]]?.[this.component_data["CPF"]["partner"]]?.[this.component_data["CPF"]["channel"]]?.[this.component_data["CPF"]["product"]] || {}
      );

    },
    cpm_options() {
      if (
        this.component_data["CPF"]["market"] == null ||
        this.component_data["CPF"]["partner"] == null ||
        this.component_data["CPF"]["channel"] == null ||
        this.component_data["CPF"]["product"] == null ||
        this.component_data["CPF"]["format"] == null
      ) {
        return null;
      }

      return this.inventory_options[this.component_data["CPF"]["market"]]?.[this.component_data["CPF"]["partner"]]?.[this.component_data["CPF"]["channel"]]?.[this.component_data["CPF"]["product"]]?.[this.component_data["CPF"]["format"]][0] || null

    },
    uses_inputted_audience() {
      return this.audience_only ? this.custom_audience_type === "inputted_value" : this.is_google_product;
    },
    audience_mode_options() {
      return [
        {
          text: "Create Audience",
          description: this.uses_inputted_audience ? "Enter a name and size" : "Build with audience variables",
          icon: "mdi-account-plus-outline",
          value: "custom",
        },
        {
          text: "Use Saved Audience",
          description: "Choose from your audiences",
          icon: "mdi-account-group-outline",
          value: "existing_audience",
        },
      ];
    },
    saved_audience_options() {
      return this.audience_options.map(audience => ({
        text: `${audience.audience_name} (${audience.audience_size_id != null ? 'Saved size' : 'Audience definition'})`,
        value: this.savedAudienceKey(audience),
      }));
    },
    selected_saved_audience() {
      return this.audience_options.find(audience => this.savedAudienceKey(audience) === this.selected_audience_key) || null;
    },
    formatted_audience_size() {
      const size = this.component_data.plan.audience_size;
      return size == null || size === "" ? "" : Number(size).toLocaleString("en-US");
    },
    market_max_audience_size() {
      if (this.audience_only) {
        const sizes = (this.audience_components || []).map(({ market, partner, channel, product, format }) =>
          Number(this.inventory_options[market]?.[partner]?.[channel]?.[product]?.[format]?.[2])
        ).filter(size => Number.isInteger(size) && size > 0);
        return sizes.length ? Math.min(...sizes) : null;
      }
      const { market, partner, channel, product, format } = this.component_data.CPF;
      const size = Number(this.inventory_options[market]?.[partner]?.[channel]?.[product]?.[format]?.[2]);
      return Number.isInteger(size) && size > 0 ? size : null;
    },
    digital_options() {
      if (
        this.component_data["CPF"]["market"] == null ||
        this.component_data["CPF"]["partner"] == null ||
        this.component_data["CPF"]["channel"] == null ||
        this.component_data["CPF"]["product"] == null ||
        this.component_data["CPF"]["format"] == null
      ) {
        return false;
      }

      return this.inventory_options[this.component_data["CPF"]["market"]]?.[this.component_data["CPF"]["partner"]]?.[this.component_data["CPF"]["channel"]]?.[this.component_data["CPF"]["product"]]?.[this.component_data["CPF"]["format"]][1] || false

    },
    days_of_week() {
      return DAYS_OF_WEEK;
    },
    time_options() {
      return TIME_OPTIONS;
    },
    shared_schedule_active_days() {
      return this.days_of_week
        .filter(
          (day) => this.component_data["plan"]["weekday_schedules"][day.value].enabled
        )
        .map((day) => day.value);
    },
    shared_schedule_time_slots() {
      const representativeDay = this.component_data["plan"]["weekday_schedules"][
        this.days_of_week[0].value
      ];

      return representativeDay ? representativeDay.time_slots : [];
    },
    isDefaultScheduleMode() {
      return this.component_data["plan"]["schedule_mode"] === "default";
    },
    schedule_summary() {
      if (this.component_data["plan"]["schedule_mode"] === "default") {
        return "Default schedule: Mon, Tue, Wed, Thu, Fri, Sat, Sun, 00:00-23:59";
      }

      if (this.component_data["plan"]["schedule_mode"] === "same_every_day") {
        const activeDays = this.shared_schedule_active_days;
        if (activeDays.length === 0) {
          return "Select at least one day for the day parting schedule.";
        }

        return `${this.formatDaySummary(activeDays)}, ${this.formatTimeSlotsSummary(
          this.shared_schedule_time_slots
        )}`;
      }

      return this.days_of_week
        .filter((day) => {
          return this.component_data["plan"]["weekday_schedules"][day.value].enabled;
        })
        .map((day) => {
          const schedule = this.component_data["plan"]["weekday_schedules"][day.value];
          return `${day.label}: ${this.formatTimeSlotsSummary(schedule.time_slots)}`;
        })
        .join(" | ");
    },
    schedule_validation_message() {
      return this.getScheduleValidationMessage();
    },
    grouped_audience_variables() {
      return this.audience_variables.reduce((variables, row) => {
        const normalizedRow = Array.isArray(row)
          ? {
              var_id: row[0],
              var_code: row[1],
              var_id_name: row[2],
              var_code_name: row[3],
            }
          : row;

        if (!normalizedRow || normalizedRow.var_id == null) {
          return variables;
        }

        const variableKey = normalizedRow.var_id;
        if (!variables[variableKey]) {
          variables[variableKey] = {
            var_id: normalizedRow.var_id,
            var_id_name: normalizedRow.var_id_name || normalizedRow.var_id,
            codes: [],
          };
        }

        variables[variableKey].codes.push({
          var_code: normalizedRow.var_code,
          var_code_name: normalizedRow.var_code_name || normalizedRow.var_code,
        });

        return variables;
      }, {});
    },
    audience_variable_list() {
      return Object.values(this.grouped_audience_variables).map((variable) => ({
        ...variable,
        codes: variable.codes.sort((codeA, codeB) => {
          return String(codeA.var_code_name).localeCompare(String(codeB.var_code_name));
        }),
      }));
    },
    filtered_audience_variables() {
      const searchText = this.audience_variable_search.trim().toLowerCase();
      if (!searchText) {
        return this.audience_variable_list;
      }

      return this.audience_variable_list.filter((variable) => {
        const variableText = `${variable.var_id} ${variable.var_id_name}`.toLowerCase();
        const codeText = variable.codes
          .map((code) => `${code.var_code} ${code.var_code_name}`)
          .join(" ")
          .toLowerCase();
        return variableText.includes(searchText) || codeText.includes(searchText);
      });
    },
    audience_variable_options() {
      return this.audience_variable_list.map((variable) => ({
        text: variable.var_id_name || variable.var_id,
        value: variable.var_id,
      }));
    },
    audience_expression_summary() {
      const expression = this.buildAudiencePayload()?.expression;
      return expression || "No audience filters selected.";
    },
    audience_validation_message() {
      return this.getAudienceValidationMessage();
    },
    trimmed_plan_name() {
      return this.component_data["plan"]["name"].trim();
    },
    create_disabled() {
      if (this.audience_only) return this.is_loading_components || this.audience_validation_message !== "";
      return (
        this.is_loading_components ||
        this.trimmed_plan_name === "" ||
        !this.isValidFrequencyCap(this.component_data["plan"]["freq_cap"]) ||
        this.component_data["CPF"]["market"] == null ||
        this.component_data["CPF"]["partner"] == null ||
        this.component_data["CPF"]["channel"] == null ||
        this.component_data["CPF"]["product"] == null ||
        this.component_data["CPF"]["format"] == null ||
        this.component_data["CPF"]["cpm"] === null ||
        this.component_data["CPF"]["cpm"] === undefined ||
        this.component_data["CPF"]["cpm"] === '' ||
        this.audience_validation_message !== ""
      );
    },
  },
  watch: {
    market_max_audience_size(size, previousSize) {
      if (this.is_initializing_component_data) {
        return;
      }
      const currentSize = this.component_data.plan.audience_size;
      if (currentSize == null || currentSize === previousSize || (size != null && Number(currentSize) > size)) {
        this.component_data.plan.audience_size = size;
      }
    },
    is_google_product(isGoogle) {
      if (isGoogle) {
        this.resetSchedule();
        if (!this.audience_only) this.variables_tab = 0;
      } else if (this.variables_tab === 2 && !this.audience_only) {
        this.variables_tab = 0;
      }
    },
    is_pattison_product(isPattison) {
      if (isPattison) {
        this.component_data.plan.freq_cap = 0;
      } else if (this.variables_tab === 1 && !this.audience_only) {
        this.variables_tab = 0;
      }
    },
    digital_options(isDigital) {
      if (!isDigital && this.variables_tab === 1 && !this.audience_only) {
        this.variables_tab = 0;
      }
    },
    market_options(newOptions) {
      if (newOptions.length === 1) {
        this.component_data["CPF"]["market"] = newOptions[0];
        return;
      }

      if (!newOptions.includes(this.component_data["CPF"]["market"])) {
        this.component_data["CPF"]["market"] = null;
      }
    },
    partner_options(newOptions) {
      if (newOptions.length === 1) {
        this.component_data["CPF"]["partner"] = newOptions[0];
        return;
      }

      if (!newOptions.includes(this.component_data["CPF"]["partner"])) {
        this.component_data["CPF"]["partner"] = null;
      }
    },
    channel_options(newOptions) {
      if (newOptions.length === 1) {
        this.component_data["CPF"]["channel"] = newOptions[0];
        return;
      }

      if (!newOptions.includes(this.component_data["CPF"]["channel"])) {
        this.component_data["CPF"]["channel"] = null;
      }
    },
    product_options(newOptions) {
      if (newOptions.length === 1) {
        this.component_data["CPF"]["product"] = newOptions[0];
        return;
      }

      if (!newOptions.includes(this.component_data["CPF"]["product"])) {
        this.component_data["CPF"]["product"] = null;
      }
    },
    format_options(newOptions) {
      if (newOptions.length === 1) {
        this.component_data["CPF"]["format"] = newOptions[0];
        return;
      }

      if (!newOptions.includes(this.component_data["CPF"]["format"])) {
        this.component_data["CPF"]["format"] = null;
      }
    },
    cpm_options(newOptions){
      if (this.is_initializing_component_data) {
        return;
      }

      this.component_data['CPF']['cpm'] = this.roundCpm(newOptions);
      this.component_data['CPF']['discount'] = null;
    }
  },
  methods: {
    restoreSharedAudience(audience) {
      this.audience_mode = audience && (audience.audience_size_id != null || audience.audience_id != null)
        ? "existing_audience" : "custom";
      this.selected_audience_key = audience ? this.savedAudienceKey(audience) : null;
      this.custom_audience_type = audience?.type === "relational_algebra" ? "relational_algebra" : "inputted_value";
      this.component_data.plan.audience_name = audience?.audience_name || "";
      this.component_data.plan.audience_size = audience?.audience_size ?? this.market_max_audience_size;
      this.component_data.audience.clauses = this.normalizeAudiencePayload(audience);
    },
    savedAudienceKey(audience) {
      return audience.audience_size_id != null
        ? `size:${audience.audience_size_id}`
        : `definition:${audience.audience_id}`;
    },
    updateAudienceSize(value) {
      const digits = String(value ?? "").replace(/[^0-9]/g, "");
      const size = digits === "" ? null : Number(digits);
      this.component_data.plan.audience_size = size == null
        ? null
        : Math.min(size, this.market_max_audience_size ?? Number.MAX_SAFE_INTEGER);
      // Refresh the displayed text even when clamping keeps the stored value unchanged.
      this.$nextTick(() => {
        const field = this.$refs.audienceSizeInput;
        if (field && field.$refs.input) {
          field.$refs.input.value = this.formatted_audience_size;
        }
      });
    },
    normalizeFrequencyCapPeriod(value) {
      const legacyPeriods = { daily: 1, weekly: 7, monthly: 30 };
      const days = legacyPeriods[value] || Number(value);
      return [1, 7, 30].includes(days) ? days : 1;
    },
    isValidFrequencyCap(value) {
      if (value === null || value === undefined || String(value).trim() === "" || typeof value === "boolean") {
        return false;
      }
      if (this.is_pattison_product) {
        return value === 0;
      }
      return Number.isInteger(Number(value)) && Number(value) >= 0;
    },
    roundCpm(value) {
      if (value === null || value === undefined || value === "") {
        return value;
      }

      const numericValue = Number(value);

      if (!Number.isFinite(numericValue)) {
        return value;
      }

      return Number(numericValue.toFixed(2));
    },
    normalizeCpm() {
      this.component_data["CPF"]["cpm"] = this.roundCpm(
        this.component_data["CPF"]["cpm"]
      );
    },
    clampWeeks(value) {
      const numericValue = Number(value);

      if (!Number.isFinite(numericValue)) {
        return 4;
      }

      return Math.min(Math.max(Math.round(numericValue), 1), 52);
    },
    normalizeWeeks() {
      this.component_data["plan"]["weeks"] = this.clampWeeks(
        this.component_data["plan"]["weeks"]
      );
    },
    cloneTimeSlots(timeSlots = []) {
      return timeSlots.map((slot) => ({
        start: slot.start,
        end: slot.end,
      }));
    },
    formatDaySummary(dayValues) {
      const labels = this.days_of_week
        .filter((day) => dayValues.includes(day.value))
        .map((day) => day.label);

      return labels.join(", ");
    },
    formatTimeSlotsSummary(timeSlots) {
      if (!timeSlots || timeSlots.length === 0) {
        return "No time slots";
      }

      return timeSlots.map((slot) => `${slot.start}-${slot.end}`).join(", ");
    },
    handleScheduleModeChange(newMode) {
      const previousMode = this.previous_schedule_mode;

      if (newMode === "default") {
        if (previousMode !== "default") {
          this.last_non_default_weekday_schedules = cloneWeekdayScheduleMap(
            this.component_data["plan"]["weekday_schedules"]
          );
        }

        this.applyDefaultSchedule();
        this.previous_schedule_mode = newMode;
        return;
      }

      if (previousMode === "default") {
        this.component_data["plan"]["weekday_schedules"] = cloneWeekdayScheduleMap(
          this.last_non_default_weekday_schedules
        );
      }

      if (newMode === "by_weekday") {
        this.previous_schedule_mode = newMode;
        return;
      }

      this.normalizeSharedSchedule();
      this.previous_schedule_mode = newMode;
    },
    applyDefaultSchedule() {
      this.component_data["plan"][
        "weekday_schedules"
      ] = createDefaultWeekdayScheduleMap();
    },
    handleSharedDayToggle(dayValue) {
      const currentEnabled = this.component_data["plan"]["weekday_schedules"][dayValue]
        .enabled;
      this.$set(
        this.component_data["plan"]["weekday_schedules"][dayValue],
        "enabled",
        !currentEnabled
      );
    },
    handleSharedTimeChange(slotIndex, field, value) {
      const nextTimeSlots = this.cloneTimeSlots(this.shared_schedule_time_slots);
      this.$set(nextTimeSlots[slotIndex], field, value);
      this.setSharedTimeSlots(nextTimeSlots);
    },
    addSharedTimeSlot() {
      const nextTimeSlots = [
        ...this.cloneTimeSlots(this.shared_schedule_time_slots),
        createTimeSlot(),
      ];
      this.setSharedTimeSlots(nextTimeSlots);
    },
    removeSharedTimeSlot(slotIndex) {
      if (this.shared_schedule_time_slots.length === 1) {
        return;
      }

      const nextTimeSlots = this.cloneTimeSlots(this.shared_schedule_time_slots);
      nextTimeSlots.splice(slotIndex, 1);
      this.setSharedTimeSlots(nextTimeSlots);
    },
    handleWeekdayEnabledChange(dayValue, enabled) {
      this.$set(
        this.component_data["plan"]["weekday_schedules"][dayValue],
        "enabled",
        enabled
      );

      if (
        enabled &&
        this.component_data["plan"]["weekday_schedules"][dayValue].time_slots.length === 0
      ) {
        this.$set(
          this.component_data["plan"]["weekday_schedules"][dayValue],
          "time_slots",
          [createTimeSlot()]
        );
      }
    },
    handleWeekdayTimeChange(dayValue, slotIndex, field, value) {
      this.$set(
        this.component_data["plan"]["weekday_schedules"][dayValue].time_slots[slotIndex],
        field,
        value
      );
    },
    addWeekdayTimeSlot(dayValue) {
      this.component_data["plan"]["weekday_schedules"][dayValue].time_slots.push(
        createTimeSlot()
      );
    },
    removeWeekdayTimeSlot(dayValue, slotIndex) {
      if (
        this.component_data["plan"]["weekday_schedules"][dayValue].time_slots.length === 1
      ) {
        return;
      }

      this.component_data["plan"]["weekday_schedules"][dayValue].time_slots.splice(
        slotIndex,
        1
      );
    },
    setSharedTimeSlots(timeSlots) {
      this.days_of_week.forEach((day) => {
        this.$set(
          this.component_data["plan"]["weekday_schedules"][day.value],
          "time_slots",
          this.cloneTimeSlots(timeSlots)
        );
      });
    },
    normalizeSharedSchedule() {
      const firstEnabledDay = this.days_of_week.find((day) => {
        return this.component_data["plan"]["weekday_schedules"][day.value].enabled;
      });
      const sourceTimeSlots = firstEnabledDay
        ? this.component_data["plan"]["weekday_schedules"][firstEnabledDay.value]
            .time_slots
        : [createTimeSlot()];

      this.setSharedTimeSlots(sourceTimeSlots);
    },
    getTimeSlotValidationMessage(timeSlots, label) {
      if (!timeSlots || timeSlots.length === 0) {
        return `${label} needs at least one time slot.`;
      }

      const sortedSlots = this.cloneTimeSlots(timeSlots).sort((slotA, slotB) => {
        return slotA.start.localeCompare(slotB.start);
      });

      const invalidSlotIndex = sortedSlots.findIndex((slot) => slot.start >= slot.end);
      if (invalidSlotIndex >= 0) {
        return `${label} slot ${
          invalidSlotIndex + 1
        } needs an end time later than its start time.`;
      }

      for (let index = 1; index < sortedSlots.length; index += 1) {
        if (sortedSlots[index].start < sortedSlots[index - 1].end) {
          return `${label} has overlapping time slots.`;
        }
      }

      return "";
    },
    getScheduleValidationMessage() {
      if (this.component_data["plan"]["schedule_mode"] === "default") {
        return "";
      }

      if (this.component_data["plan"]["schedule_mode"] === "same_every_day") {
        if (this.shared_schedule_active_days.length === 0) {
          return "Select at least one day for the schedule.";
        }

        const sharedValidationMessage = this.getTimeSlotValidationMessage(
          this.shared_schedule_time_slots,
          "Shared schedule"
        );

        if (sharedValidationMessage) {
          return sharedValidationMessage;
        }

        return "";
      }

      const enabledSchedules = this.days_of_week.filter((day) => {
        return this.component_data["plan"]["weekday_schedules"][day.value].enabled;
      });

      if (enabledSchedules.length === 0) {
        return "Enable at least one weekday schedule.";
      }

      const invalidDay = enabledSchedules.find((day) => {
        const schedule = this.component_data["plan"]["weekday_schedules"][day.value];
        return (
          this.getTimeSlotValidationMessage(schedule.time_slots, day.fullLabel) !== ""
        );
      });

      if (invalidDay) {
        return this.getTimeSlotValidationMessage(
          this.component_data["plan"]["weekday_schedules"][invalidDay.value].time_slots,
          invalidDay.fullLabel
        );
      }

      return "";
    },
    buildSchedulePayload() {
      const weekdaySchedules =
        this.component_data["plan"]["schedule_mode"] === "default"
          ? createDefaultWeekdayScheduleMap()
          : this.days_of_week.reduce((scheduleMap, day) => {
              scheduleMap[day.value] = {
                enabled: this.component_data["plan"]["weekday_schedules"][day.value]
                  .enabled,
                time_slots: this.cloneTimeSlots(
                  this.component_data["plan"]["weekday_schedules"][day.value].time_slots
                ),
              };
              return scheduleMap;
            }, {});

      return {
        mode: this.component_data["plan"]["schedule_mode"],
        weekday_schedules: weekdaySchedules,
      };
    },
    getAudienceCodeOptions(varId) {
      if (!varId || !this.grouped_audience_variables[varId]) {
        return [];
      }

      return this.grouped_audience_variables[varId].codes.map((code) => ({
        text: code.var_code_name || code.var_code,
        value: code.var_code,
      }));
    },
    handleAudienceVariableChange(clause) {
      this.$set(clause, "var_codes", []);
    },
    addAudienceClause() {
      this.component_data["audience"]["clauses"].push(createAudienceClause("AND"));
    },
    removeAudienceClause(clauseIndex) {
      if (this.component_data["audience"]["clauses"].length === 1) {
        return;
      }

      this.component_data["audience"]["clauses"].splice(clauseIndex, 1);
    },
    getAudienceValidationMessage() {
      if (this.audience_managed && !this.audience_only) return "";
      if (this.audience_mode === "existing_audience") {
        return this.selected_saved_audience ? "" : "Select a saved audience.";
      }
      if (this.uses_inputted_audience) {
        const size = Number(this.component_data.plan.audience_size);
        if (!Number.isInteger(size) || size <= 0) {
          return "Enter a positive whole number for audience size.";
        }
        if (this.market_max_audience_size != null && size > this.market_max_audience_size) {
          return `Audience size cannot exceed the market maximum of ${this.market_max_audience_size.toLocaleString()}.`;
        }
        return "";
      }
      const clauses = this.component_data["audience"]["clauses"] || [];
      const populatedClauses = clauses.filter((clause) => {
        return clause.var_id || (clause.var_codes && clause.var_codes.length > 0);
      });

      if (populatedClauses.length === 0) {
        return "";
      }

      const incompleteClauseIndex = clauses.findIndex((clause) => {
        return (
          clause.var_id &&
          (!clause.var_codes || clause.var_codes.length === 0)
        );
      });

      if (incompleteClauseIndex >= 0) {
        return `Audience clause ${incompleteClauseIndex + 1} needs at least one code.`;
      }

      const missingVariableIndex = clauses.findIndex((clause) => {
        return !clause.var_id && clause.var_codes && clause.var_codes.length > 0;
      });

      if (missingVariableIndex >= 0) {
        return `Audience clause ${missingVariableIndex + 1} needs a variable.`;
      }

      return "";
    },
    getAudienceVariableName(varId) {
      return this.grouped_audience_variables[varId]?.var_id_name || varId;
    },
    getAudienceCodeName(varId, varCode) {
      const variable = this.grouped_audience_variables[varId];
      const code = variable?.codes.find((variableCode) => {
        return variableCode.var_code === varCode;
      });
      return code?.var_code_name || varCode;
    },
    buildAudiencePayload() {
      if (this.audience_managed && !this.audience_only) {
        return audienceForPayload(this.shared_audience, this.audience_options) || { type: "relational_algebra", clauses: [], expression: "" };
      }
      if (this.audience_mode === "existing_audience") {
        const audience = this.selected_saved_audience;
        return audienceForPayload(audience, this.audience_options);
      }
      if (this.uses_inputted_audience) {
        return {
          type: this.audience_only ? "inputted-value" : "inputted_value",
          audience_name: this.component_data.plan.audience_name.trim(),
          audience_size: Number(this.component_data.plan.audience_size),
        };
      }

      const clauses = (this.component_data["audience"]["clauses"] || [])
        .filter((clause) => clause.var_id && clause.var_codes.length > 0)
        .map((clause, index) => {
          const codeLabels = clause.var_codes.map((varCode) => {
            return this.getAudienceCodeName(clause.var_id, varCode);
          });
          const setExpression = `${this.getAudienceVariableName(clause.var_id)} IN (${codeLabels.join(", ")})`;
          const expression = clause.negated ? `NOT ${setExpression}` : setExpression;

          return {
            join: index === 0 ? null : clause.join,
            operator: clause.negated ? "NOT IN" : "IN",
            var_id: clause.var_id,
            var_codes: [...clause.var_codes],
            expression,
          };
        });

      return {
        type: "relational_algebra",
        clauses,
        expression: clauses
          .map((clause, index) => {
            return `${index === 0 ? "" : `${clause.join} `}${clause.expression}`;
          })
          .join(" "),
      };
    },
    resetSchedule() {
      this.component_data["plan"]["schedule_mode"] = "default";
      this.component_data["plan"]["weekday_schedules"] = createDefaultWeekdayScheduleMap();
      this.last_non_default_weekday_schedules = createWeekdayScheduleMap();
      this.previous_schedule_mode = "default";
    },
    normalizeSchedulePayload(eventSchedule) {
      if (
        eventSchedule &&
        typeof eventSchedule === "object" &&
        eventSchedule["weekday_schedules"]
      ) {
        return {
          mode: eventSchedule["mode"] || "same_every_day",
          weekday_schedules: cloneWeekdayScheduleMap(eventSchedule["weekday_schedules"]),
        };
      }

      return {
        mode: "same_every_day",
        weekday_schedules: createWeekdayScheduleMap(),
      };
    },
    applyInitialComponentData() {
      if (!this.is_edit_mode || !this.edit_component_data) {
        return;
      }

      this.is_initializing_component_data = true;

      const schedule = this.normalizeSchedulePayload(
        this.edit_component_data["event_schedule"]
      );

      this.component_data["CPF"]["market"] = this.edit_component_data["market"];
      this.component_data["CPF"]["partner"] = this.edit_component_data["partner"];
      this.component_data["CPF"]["channel"] = this.edit_component_data["channel"];
      this.component_data["CPF"]["product"] = this.edit_component_data["product"];
      this.component_data["CPF"]["format"] = this.edit_component_data["format"];
      this.component_data["CPF"]["cpm"] = this.roundCpm(this.edit_component_data["cpm"]);
      this.component_data["CPF"]["discount"] =
        this.edit_component_data["discount"] == null
          ? null
          : this.edit_component_data["discount"];
      this.component_data["plan"]["name"] =
        this.edit_component_data["plan_name"] || "";
      const savedAudience = this.edit_component_data.audience;
      if (savedAudience && (savedAudience.audience_id != null || savedAudience.audience_size_id != null)) {
        this.audience_mode = "existing_audience";
        this.selected_audience_key = this.savedAudienceKey(savedAudience);
      } else {
        this.audience_mode = "custom";
        this.selected_audience_key = null;
      }
      this.component_data.plan.audience_name =
        this.edit_component_data.audience?.audience_name ?? this.edit_component_data.audience_name ?? "";
      this.component_data.plan.audience_size =
        this.edit_component_data.audience?.audience_size ?? this.edit_component_data.audience_size ?? this.market_max_audience_size;
      this.component_data["plan"]["weeks"] =
        this.clampWeeks(this.edit_component_data["weeks"] || 4);
      this.component_data["plan"]["freq_cap"] =
        this.is_pattison_product ? 0 : (this.edit_component_data["freq_cap"] ?? 3);
      this.component_data["plan"]["freq_cap_period"] =
        this.normalizeFrequencyCapPeriod(this.edit_component_data["freq_cap_period"]);
      this.component_data["plan"]["schedule_mode"] = schedule["mode"];
      this.component_data["plan"]["weekday_schedules"] =
        schedule["weekday_schedules"];
      this.component_data["audience"]["clauses"] = this.normalizeAudiencePayload(
        this.edit_component_data["audience"]
      );
      this.last_non_default_weekday_schedules =
        schedule["mode"] === "default"
          ? createWeekdayScheduleMap()
          : cloneWeekdayScheduleMap(schedule["weekday_schedules"]);
      this.previous_schedule_mode = schedule["mode"];
      if (this.is_google_product) {
        this.resetSchedule();
      }

      this.$nextTick(() => {
        this.is_initializing_component_data = false;
      });
    },
    buildComponentPayload() {
      return {
        plan_name: this.trimmed_plan_name,
        market: this.component_data["CPF"]["market"],
        partner: this.component_data["CPF"]["partner"],
        channel: this.component_data["CPF"]["channel"],
        product: this.component_data["CPF"]["product"],
        format: this.component_data["CPF"]["format"],
        cpm: this.roundCpm(this.component_data["CPF"]["cpm"]),
        discount: this.component_data["CPF"]["discount"] ? this.component_data["CPF"]["discount"] : 0,
        weeks: this.clampWeeks(this.component_data["plan"]["weeks"]),
        freq_cap: this.is_pattison_product ? 0 : Number(this.component_data["plan"]["freq_cap"]),
        freq_cap_period: this.normalizeFrequencyCapPeriod(this.component_data["plan"]["freq_cap_period"]),
        event_schedule: this.buildSchedulePayload(),
        audience: this.buildAudiencePayload(),
      };
    },
    normalizeAudiencePayload(audiencePayload) {
      if (!audiencePayload || !Array.isArray(audiencePayload["clauses"])) {
        return [createAudienceClause()];
      }

      const clauses = audiencePayload["clauses"].map((clause, index) => ({
        id: ++audienceClauseId,
        join: index === 0 ? "AND" : clause.join || "AND",
        negated: clause.operator === "NOT IN" || clause.negated === true,
        var_id: clause.var_id || null,
        var_codes: clause.var_codes || [],
      }));

      return clauses.length > 0 ? clauses : [createAudienceClause()];
    },
    // Resets all editable setup fields to their initial create-dialog state.
    resetComponentState() {
      this.audience_mode = "custom";
      this.selected_audience_key = null;
      this.variables_tab = 0;
      this.component_data["CPF"]["market"] = null;
      this.component_data["CPF"]["partner"] = null;
      this.component_data["CPF"]["channel"] = null;
      this.component_data["CPF"]["product"] = null;
      this.component_data["CPF"]["format"] = null;
      this.component_data["plan"]["name"] = "";
      this.component_data.plan.audience_name = "";
      this.component_data.plan.audience_size = null;
      this.component_data["plan"]["weeks"] = 4;
      this.component_data["plan"]["freq_cap"] = 3;
      this.component_data["plan"]["freq_cap_period"] = 1;
      this.component_data["audience"]["clauses"] = [createAudienceClause()];
      this.schedule_validation_attempted = false;
      this.audience_validation_attempted = false;
      this.resetSchedule();
    },
    // Clears setup state before notifying the parent dialog to close.
    closeSetup() {
      this.resetComponentState();
      this.$emit("close");
    },
    fetch_component_options: async function () {
      this.is_loading_components = true;
      try {
        let token = await this.$auth.getTokenSilently();
        let payload = {
          project_id: this.$project.get_val(),
        };
        let result = await sweetspot_reporting_api_caller
          .fetch_component_options(token, payload)
          .then((resp) => {
            if (resp["success"]) {
              return resp["data"];
            }
            return false;
          })
          .catch((e) => {
            console.log("error", e);
            return false;
          });
        if (result) {
          this.inventory_options = result["inventory_options"] || {};
          this.audience_options = result["audience_options"] || [];
          this.audience_variables =
            result["audience_variables"] ||
            result["audience_variable_options"] ||
            result["variables"] ||
            [];
          this.available_markets =
            result["component_options"]?.["market"] ||
            result["market"] ||
            Object.keys(this.inventory_options);
        }
      } catch (e) {
        console.log("error", e);
      } finally {
        this.is_loading_components = false;
      }
    },
    add_component: async function () {
      if (this.create_disabled || this.is_submitting) {
        return;
      }

      this.schedule_validation_attempted = true;
      this.audience_validation_attempted = true;

      if (this.schedule_validation_message || this.audience_validation_message) {
        return;
      }

      this.is_submitting = true;
      this.$emit("component_submission_started", "create");

      let payload = {
        project_id: this.$project.get_val(),
        report_id: this.report_id,
        create_payload: this.buildComponentPayload(),
      };

      let token = await this.$auth.getTokenSilently();

      let result = await sweetspot_reporting_api_caller
        .add_component(token, payload)
        .then((resp) => {
          if (resp["success"]) {
            return resp["data"];
          }
          return false;
        })
        .catch((e) => {
          console.log("error", e);
          return false;
        });
      if (result && result["new_plan"]) {
        let temp_new_component = result["new_plan"];
        temp_new_component["plan_name"] =
          temp_new_component["plan_name"] || payload["create_payload"]["plan_name"];
        temp_new_component["event_schedule"] =
          temp_new_component["event_schedule"] ||
          payload["create_payload"]["event_schedule"];
        temp_new_component["audience"] =
          temp_new_component["audience"] || payload["create_payload"]["audience"];
        temp_new_component["report_updated_time"] =
          result["updated_time"] ||
          result["updated_at"] ||
          result["last_updated"] ||
          new Date().toISOString();

        this.resetComponentState();

        this.$emit("close");
        this.$emit("component_setup_completed", temp_new_component);
      } else {
        this.is_submitting = false;
        this.$emit("component_setup_failed");
      }
    },
    edit_component: async function () {
      if (this.create_disabled || this.is_submitting || !this.edit_component_data) {
        return;
      }

      this.schedule_validation_attempted = true;
      this.audience_validation_attempted = true;

      if (this.schedule_validation_message || this.audience_validation_message) {
        return;
      }

      this.is_submitting = true;
      this.$emit("component_submission_started", "edit");

      const payload = {
        project_id: this.$project.get_val(),
        report_id: this.report_id,
        plan_id: this.edit_component_data["plan_id"],
        component_id: this.edit_component_data["component_id"],
        update_payload: this.buildComponentPayload(),
      };

      let token = await this.$auth.getTokenSilently();

      let result = await sweetspot_reporting_api_caller
        .edit_component(token, payload)
        .then((resp) => {
          if (resp["success"]) {
            return resp["data"];
          }
          return false;
        })
        .catch((e) => {
          console.log("error", e);
          return false;
        });

      if (result) {
        const updated_component =
          result["updated_plan"] ||
          result["edited_plan"] ||
          result["component"] ||
          result["plan"] ||
          null;

        const fallback_component = {
          ...this.edit_component_data,
          ...payload["update_payload"],
          plan_id: this.edit_component_data["plan_id"],
          component_id: this.edit_component_data["component_id"],
        };

        let temp_updated_component = updated_component || fallback_component;
        temp_updated_component["plan_name"] =
          temp_updated_component["plan_name"] || payload["update_payload"]["plan_name"];
        temp_updated_component["event_schedule"] =
          temp_updated_component["event_schedule"] ||
          payload["update_payload"]["event_schedule"];
        temp_updated_component["audience"] =
          temp_updated_component["audience"] || payload["update_payload"]["audience"];
        temp_updated_component["report_updated_time"] =
          result["updated_time"] ||
          result["updated_at"] ||
          result["last_updated"] ||
          new Date().toISOString();

        this.resetComponentState();

        this.$emit("close");
        this.$emit("component_edit_completed", temp_updated_component);
      } else {
        this.is_submitting = false;
        this.$emit("component_setup_failed");
      }
    },
    save_component: async function () {
      if (this.audience_only) {
        if (!this.create_disabled) this.$emit("audience_saved", this.buildAudiencePayload());
        return;
      }
      if (this.is_edit_mode) {
        await this.edit_component();
        return;
      }

      await this.add_component();
    },
  },
};
</script>

<style scoped>
.component-info-layout.component-info-layout--audience {
  grid-template-columns: minmax(0, 1fr);
  grid-template-rows: minmax(0, 1fr);
}

.audience-source-switch {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  width: 100%;
  max-width: 440px;
  gap: 4px;
  padding: 4px;
  border: 1px solid #e8eaf0;
  border-radius: 12px;
  background: #f3f4f7;
}

.audience-source-option {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  padding: 7px 9px;
  border: 1px solid transparent;
  border-radius: 8px;
  text-align: left;
  transition: background-color 160ms ease, box-shadow 160ms ease, border-color 160ms ease;
}

.audience-source-option:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.65);
}

.audience-source-option.audience-source-option--active {
  background: #fff;
  border-color: #e0e3eb;
  box-shadow: 0 2px 6px rgba(25, 35, 60, 0.08);
}

.audience-source-option:focus-visible {
  outline: 2px solid var(--v-primary-base, #1976d2);
  outline-offset: 2px;
}

.audience-source-option:disabled {
  opacity: 0.5;
  cursor: default;
}

.audience-source-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 26px;
  height: 26px;
  border-radius: 7px;
  background: #edf0f5;
}

.audience-source-copy {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
  gap: 1px;
}

.audience-source-title {
  font-size: 12px;
  font-weight: 600;
  color: #252d3d;
}

.audience-source-description {
  font-size: 10px;
  line-height: 1.4;
  color: #707889;
}

@media (max-width: 600px) {
  .audience-source-switch {
    grid-template-columns: 1fr;
  }
}

@media (prefers-reduced-motion: reduce) {
  .audience-source-option {
    transition: none;
  }
}

.component-setup-card {
  position: relative;
}

.component-info-tab {
  overflow: hidden;
}

.component-info-layout {
  display: grid;
  grid-template-columns: 5fr 7fr;
  grid-template-rows: auto minmax(0, 1fr);
  height: 100%;
}

.component-info-layout > .v-col:first-child,
.component-info-layout > .col-12:first-child {
  grid-column: 1 / -1;
}

.component-section-column {
  min-height: 0;
  min-width: 0;
  max-width: 100%;
}

.component-definition-card,
.other-variables-card {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  border-radius: 12px;
}

.component-definition-card > .v-card__title,
.other-variables-card > .v-card__title,
.other-variables-card > .v-tabs {
  flex: 0 0 auto;
}

.variables-tabs {
  width: calc(100% - 32px);
  max-width: 360px;
  margin: 16px;
  padding: 4px;
  border-radius: 12px;
  background: #f1f2f4;
}

.variables-tabs ::v-deep .v-tab {
  min-width: 0;
  padding: 0 16px;
  border-radius: 9px;
  color: #626b78;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: normal;
  text-transform: none;
  transition: background-color 150ms ease, box-shadow 150ms ease;
}

.variables-tabs ::v-deep .v-tab--active {
  color: #fff;
  background: #1b1b1b;
  font-weight: 600;
  box-shadow: 0 2px 4px rgba(16, 24, 40, 0.16);
}

.variables-tabs ::v-deep .v-tab .v-icon {
  color: inherit;
}

.variables-tabs ::v-deep .v-tab:focus-visible {
  outline: 2px solid currentColor;
  outline-offset: -2px;
}

.component-definition-content,
.other-variables-content {
  flex: 1 1 0;
  min-height: 0;
  overflow-y: auto;
}

@media (max-width: 959px) {
  .component-info-layout {
    grid-template-columns: minmax(0, 1fr);
    grid-template-rows: auto minmax(0, 1fr) minmax(0, 1fr);
  }
}

.component-loading-state {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: inherit;
  z-index: 2;
  pointer-events: none;
}

.event-scheduler-card {
  border-radius: 12px;
  border: 0;
}

.event-scheduler-header {
  display: block;
}

.scheduler-header-content {
  width: 100%;
}

.scheduler-summary-row {
  width: 100%;
  margin-top: 16px;
}

.scheduler-summary-alert {
  width: 100%;
}

.audience-builder {
  align-content: flex-start;
  overflow: hidden;
}

.audience-builder__sidebar,
.audience-builder__workspace {
  height: 73vh;
}

.audience-builder-card {
  border-radius: 12px;
  height: calc(73vh - 48px);
  overflow-y: auto;
}

.audience-builder-header {
  align-items: flex-start;
}

.audience-variable-name {
  font-size: 0.95rem;
  font-weight: 600;
}

.audience-variable-code-count {
  color: rgba(0, 0, 0, 0.5);
  font-size: 0.78rem;
}

.audience-clause-row {
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 10px;
  margin-bottom: 10px;
}

.audience-clause-label {
  color: rgba(0, 0, 0, 0.72);
  font-size: 0.85rem;
  font-weight: 600;
}

.audience-expression {
  background: rgba(0, 0, 0, 0.035);
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 10px;
  color: rgba(0, 0, 0, 0.72);
  font-size: 0.9rem;
  line-height: 1.5;
  min-height: 48px;
}

.scheduler_title {
  font-size: 1rem;
  font-weight: 600;
}

.scheduler_title_disabled {
  color: rgba(0, 0, 0, 0.38);
}

.scheduler_subtitle {
  color: rgba(0, 0, 0, 0.6);
  font-size: 0.85rem;
  line-height: 1.4;
}

.scheduler_label {
  color: rgba(0, 0, 0, 0.6);
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  margin-bottom: 8px;
  text-transform: uppercase;
}

.day-chip-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.shared-schedule-layout {
  align-content: flex-start;
  /* min-height: 45vh; */
}

.weekday-schedule-row {
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 10px;
  margin-bottom: 8px;
}

.weekday-name {
  font-size: 0.95rem;
  font-weight: 600;
}

.weekday-switch-col {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.weekday-switch-col ::v-deep .v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}

.weekday-switch-col ::v-deep .v-input__control {
  display: flex;
  align-items: center;
}

.time-slot-row {
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 10px;
  margin-bottom: 8px;
}

.slot-name {
  font-size: 0.85rem;
  font-weight: 600;
}

.weekday-off-text {
  color: rgba(0, 0, 0, 0.5);
  font-size: 0.85rem;
}
</style>


<style>
/* The select menu is attached outside the component, so these rules are global. */
.sweetspot-market-menu .market-group-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: calc(100% - 16px);
  text-align: left;
  cursor: pointer;
  height: 40px;
  margin: 4px 8px;
  padding: 0 12px;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.07);
  color: inherit;
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.sweetspot-market-menu .market-group-toggle:focus-visible {
  outline: 2px solid currentColor;
  outline-offset: -2px;
}

.sweetspot-market-menu .v-list-item {
  padding-left: 28px;
}

.sweetspot-market-menu .market-group-heading {
  padding: 0;
}

.sweetspot-market-menu .v-divider {
  margin: 12px 16px;
}
</style>
